import React from "react";
import profileImg from "../assets/images/profile.jpg";
import CvDownload from "./CvDownload";
import "../assets/styles/Main.scss";

function Main() {
  return (
    <header className="hero" id="home">
      <div className="hero-top">
        <h1 className="hero-name">
          Sərxan
          <br />
          Babayev
        </h1>
        <p className="hero-roles">
          <span className="role-solid">Product Owner</span>
          <span className="role-outline">IT Project Manager</span>
          <span className="role-accent">Biznes Analitik</span>
        </p>
      </div>

      <figure className="hero-figure">
        <div className="hero-photo">
          <img src={profileImg} alt="Sərxan Babayev" />
        </div>
        <figcaption className="hero-caption">
          <span>Bakı, Azərbaycan</span>
        </figcaption>
      </figure>

      <div className="hero-bottom">
        <p className="hero-tagline">
          «Rəqəmsal xaosu strategiyaya, mürəkkəb ideyaları isə istifadəçilərin
          sevəcəyi mükəmməl məhsullara çevirirəm.»
        </p>
        <div className="hero-cta">
          <a
            href="https://www.linkedin.com/in/sarkhan-babayev/"
            target="_blank"
            rel="noreferrer"
            className="btn btn-linkedin"
          >
            LinkedIn ↗
          </a>
          <a
            href="https://github.com/TheSarKhan/"
            target="_blank"
            rel="noreferrer"
            className="btn btn-ghost"
          >
            GitHub ↗
          </a>
          <CvDownload variant="button" />
        </div>
      </div>
    </header>
  );
}

export default Main;
